import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TreeNode} from "primeng/api";
import {DateFilterType, Field, Filter, GroupField, isEmptinessFilterType, NumberFilterType, StringFilterType, ValueType} from "../../filter.type";

@Component({
    selector: 'dmp-filter-display',
    templateUrl: './filter-display.component.html',
    styleUrls: ['./filter-display.component.scss'],
    standalone: false
})
export class FilterDisplayComponent implements OnInit {
    @Input() rowNode!: any;
    @Output() rowNodeChange = new EventEmitter<TreeNode>();

    @Input() filter!: Filter;
    @Output() filterChange = new EventEmitter<Filter>();

    @Output() onAddGroup = new EventEmitter<string>();
    @Output() onAddFilter = new EventEmitter<string>();
    @Output() onRemoveFilter = new EventEmitter<string>();


    public string_type = Object.values(StringFilterType).map((value) => ({code: value, value}));
    public number_type = Object.values(NumberFilterType).map((value) => ({code: value, value}));
    public date_type = Object.values(DateFilterType).map((value) => ({code: value, value}));

    public readonly stringEmpty = StringFilterType.EMPTY;
    public readonly numberEmpty = NumberFilterType.EMPTY;
    public readonly dateEmpty = DateFilterType.EMPTY;
    public readonly isEmptinessFilterType = isEmptinessFilterType;
    public readonly dateSlidingRange = DateFilterType.SLIDING_RANGE;
    public readonly dateRange = DateFilterType.RANGE;
    public readonly dateExact = DateFilterType.EXACTLY;
    @Input() readOnly: boolean = false;
    /** Champs disponibles (libellés dans la langue courante) ; remplacent le libellé enregistré avec le filtre. */
    @Input() fields: Field[] | GroupField[];

  constructor() { }

  ngOnInit(): void {
  }

  get fieldLabel(): string {
    const field = this.filter?.field;
    if (!field) {
      return '';
    }
    const flatFields: Field[] = [];
    ((this.fields ?? []) as (Field | GroupField)[])
        .forEach(item => 'items' in item ? flatFields.push(...item.items) : flatFields.push(item));
    const current = flatFields.find(f => f.name === field.name && (!field.schema || f.schema === field.schema));
    return current?.label || field.label || field.name;
  }

    listToString(list: { code: string, value: string }[] | null | undefined) {
        if (!list || !Array.isArray(list)) {
            return '';
        }
        return list.reduce((acc, curr) => (acc ? acc + ', ' : '') + curr.value, '');
    }

    listType(valueType: ValueType) {
        if (['CIVILITY', 'LANG', 'TAG', 'ACTIVITY_STATUS', 'LOYALTY_STATUS', 'PURCHASE_STATUS', 'CHANNEL'].includes(valueType)) {
            return 'dropdown';
        } else {
            return 'autocomplete';
        }
    }

    addFilter() {
        this.onAddFilter.emit(this.rowNode);
    }

    addGroupFilter() {
        this.onAddGroup.emit(this.rowNode);
    }

    doDelete() {
        //this.data = this.removeNode(this.data, node);
        this.onRemoveFilter.emit(this.rowNode);
    }
    removeNode(nodes: TreeNode[], nodeToRemove: TreeNode): TreeNode[] {
        return nodes.filter(node => {
            if (node === nodeToRemove) {
                return false;
            } else if (node.children) {
                node.children = this.removeNode(node.children, nodeToRemove);
            }
            return true;
        });
    }

    checkTypeRange(code?: string) {
        if (code) {
            return [NumberFilterType.RANGE]
                .map(v => v.toString())
                .includes(code);
        } else {
            return false;
        }
    }
}
